import { datadogRum } from '@datadog/browser-rum';
import { MONITORING_TAGS } from 'constants/monitoring';
import debug from 'debug';

const log = debug('ag:runInBackground');

interface Options {
  feature?: string;
  user?: {
    email?: string;
  };
  extra?: {
    [key: string]: unknown;
  };
}

export default async function runInBackground<T>(fn: () => Promise<T>, options: Options = {}) {
  const { feature, user, extra } = options;
  try {
    await fn();
  } catch (e) {
    const context = {
      level: 'error',
      tags: { [MONITORING_TAGS.BACKGROUND_ASYNC_TASKS]: true },
      ...(feature && { feature }),
      ...(user && { user }),
      ...(extra && { extra })
    };

    datadogRum.addError(e, context);

    log(e);
  }
}
